module.exports = __webpack_public_path__ + "img/twitter.63adaddc.svg";